import React, { useEffect, useState } from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
// import './SchedulerView.css';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
function SchedulerView(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'scheduleName', headerName: 'Schedule Name', width: '300', align: 'center', headerAlign: 'center' },
        { field: 'contentName', headerName: 'Content Name', width: '300', align: 'center', headerAlign: 'center' },
        { field: 'contentType', headerName: 'ContentType', width: '300', align: 'center', headerAlign: 'center' }
    ];

    const restaurant = localStorage.getItem("restaurant");
    var res = JSON.parse(restaurant as string);
    const [scheduleData, setScheduleData] = useState([]);

    const getScehduleData = async (resId) => {
        try {
            await axios.get(
                `${process.env.REACT_APP_SECRET}/api/Schedule/getschedulebyRestaurantId/` +
                resId
            )
                .then((res) => {
                    setScheduleData(res.data);
                })
        }
        catch (ex) {
            console.log("Error Fetching Schedue Data!!", ex);
        }
    }
    useEffect(() => {
        getScehduleData(res.id);
    }, [restaurant]);

    function getRowId(row) {
        return row.id + row.scheduleName + row.contentName;
    }

    return (
        <div>
            <div>
                <FilterComponents title={"OK"} isItem={15} />
                <DataGrid
                    getRowId={getRowId}
                    columns={columns}
                    rows={scheduleData}
                    initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 5,
                          },
                        },
                      }}
                      pageSizeOptions={[5]}
                      checkboxSelection
                      disableRowSelectionOnClick
                />
                {/* <CustomDataGrid columns={columns} dataRows={scheduleData} /> */}
            </div>
        </div>
    );
}

export default SchedulerView;